var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-request-from-show-step2"},[_c('MainFormRequestShow',{attrs:{"type":_vm.type}}),_c('v-col',{attrs:{"cols":"12"}}),_c('MainFormDateTimeOtherShow',{attrs:{"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }